var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStackbar3D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04136 52.999L13.4134 53.4879L13.5875 34.1756L6.02148 33.7935L6.04136 52.999Z",
    fill: "#FCBFD9",
    stroke: "#FCBFD9",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5875 34.1757L16.4734 31.9622L9.15993 31.6069L6.02148 33.7936L13.5875 34.1757Z",
    fill: "#FF834E",
    stroke: "#FE6A35",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5881 34.1755L13.4141 53.4878L16.2346 50.6534L16.474 31.9619L13.5881 34.1755Z",
    fill: "#FAA3C8",
    stroke: "#FCBFD9",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02306 44.9655L13.589 45.3476L13.791 22.9361L6 22.6855L6.02306 44.9655Z",
    fill: "#86B5FD",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.791 22.9363L16.7522 21.4863L9.2287 21.2539L6 22.6858L13.791 22.9363Z",
    fill: "#5296FC",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7899 22.9363L13.5879 45.3478L16.4738 43.1343L16.751 21.4863L13.7899 22.9363Z",
    fill: "#5296FC",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7933 52.7069L30.1654 53.4878L30.3394 22.6401L22.7734 22.0298L22.7933 52.7069Z",
    fill: "#FCBFD9",
    stroke: "#FCBFD9",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3394 22.6403L33.2253 19.1046L25.9119 18.5371L22.7734 22.0299L30.3394 22.6403Z",
    fill: "#FF834E",
    stroke: "#FE6A35",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.34 22.6402L30.166 53.4879L32.9866 48.9605L33.2259 19.1045L30.34 22.6402Z",
    fill: "#FAA3C8",
    stroke: "#FCBFD9",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.775 39.8749L30.341 40.4853L30.543 4.68727L22.752 4.28711L22.775 39.8749Z",
    fill: "#86B5FD",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.543 4.68731L33.5041 2.37126L25.9806 2L22.752 4.28715L30.543 4.68731Z",
    fill: "#5296FC",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5418 4.68714L30.3398 40.4852L33.2257 36.9495L33.5029 2.37109L30.5418 4.68714Z",
    fill: "#5296FC",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5453 52.8706L46.9173 53.4881L47.0914 29.094L39.5254 28.6113L39.5453 52.8706Z",
    fill: "#FCBFD9",
    stroke: "#FCBFD9",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0914 29.0939L49.9773 26.2979L42.6638 25.8491L39.5254 28.6112L47.0914 29.0939Z",
    fill: "#FF834E",
    stroke: "#FE6A35",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.092 29.0944L46.918 53.4885L49.7385 49.9083L49.9779 26.2983L47.092 29.0944Z",
    fill: "#FAA3C8",
    stroke: "#FCBFD9",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.527 45.2623L47.093 45.7449L47.2949 17.4361L39.5039 17.1196L39.527 45.2623Z",
    fill: "#86B5FD",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2949 17.4361L50.2561 15.6046L42.7326 15.311L39.5039 17.1197L47.2949 17.4361Z",
    fill: "#5296FC",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2938 17.436L47.0918 45.7449L49.9777 42.9489L50.2549 15.6045L47.2938 17.436Z",
    fill: "#5296FC",
    stroke: "#86B5FD",
    strokeWidth: 0.366966,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackbar3D);
export default __webpack_public_path__ + "static/media/stackbar3d.0c5c7878c0da27e9f10daab246419f58.svg";
export { ForwardRef as ReactComponent };